import type { JSX } from 'react'

import type {
  BufferEditor,
  BufferValue,
} from '~publish/legacy/editor/BufferEditor/types.plate'
import { EditorErrorBoundary } from '~publish/legacy/editor/components/EditorErrorBoundary'

import { EditorSurface } from './EditorSurface'
import type { EditorSurfaceProps } from './EditorSurface'

type CoreComposerEditorSurfaceProps = Readonly<{
  editor: BufferEditor
  editableProps: EditorSurfaceProps<BufferValue>['editableProps']
  onChange: EditorSurfaceProps<BufferValue>['onChange']
}>

export function CoreComposerEditorSurface({
  editor,
  editableProps,
  onChange,
}: CoreComposerEditorSurfaceProps): JSX.Element {
  return (
    <EditorErrorBoundary editor={editor}>
      <EditorSurface
        editor={editor}
        editableProps={editableProps}
        onChange={onChange}
      />
    </EditorErrorBoundary>
  )
}
